export default __webpack_public_path__ + "static/media/header-navbar-item-corner.847f0d01.svg";